import { Button } from "primereact/button";


interface IUpdateList {
    deleteSetter: () => void;
}

const UpdateList = ({deleteSetter}:IUpdateList) => {
  return (
    <>
      <Button
        icon="pi pi-trash"
        className="p-button p-button-text"
        onClick={() => {
            deleteSetter()
        }}
      />
    </>
  );
};

export default UpdateList;
